const PREFIX = process.env.REACT_APP_SUPPORT_API_PREFIX ?? "api/v1";

const supportDictionary = {
  createTicket: () => `${PREFIX}/support/tickets`,
  getTickets: () => `${PREFIX}/support/tickets`,
  getTicketListing: () => `api/v1/qrc/ticket-listing`,
  getTicketDetails: (ticketNumber: string | number) => `api/v1/qrc/ticket-details/${ticketNumber}`,
  urgentRequests: () => `api/v1/qrc/urgent-requests`,
  updateTicket: () => `api/v1/qrc/update-ticket`,
  requestCallback: () => `${PREFIX}/support/callback-requests`,
  requestSMCallback: () => `${PREFIX}/user-application/request-sm-callback`,
  verifyTicket: (ticketId: string) => `api/v1/qrc/verify-ticket/${ticketId}`,
  sendOtp: () => `api/v1/qrc/otp/send`,
  verifyOtp: () => `api/v1/qrc/otp/verify`,
  stateCheckpoint: (id: string | number) => `api/v1/qrc/state-checkpoint/${id}`,
  userVerification: () => `api/v1/qrc/user-verification`,
  extendTicketTime: (ticketId: string) => `${PREFIX}/support/tickets/${ticketId}/extend`,
  submitComplaintOnTicket: () => `${PREFIX}/support/complaints/on-ticket`,
  submitComplaintNoTicket: () => `${PREFIX}/support/complaints`,
};

export default supportDictionary;
